export const gitCommit = '81f37dc0'
